/**
 * @description 顶部导航栏数据
 */

import { getMsgBadge } from '@/api/personal'

const state = {
  unreadMsgCount: 0,
}

const getters = {
  getUnreadMsgCount: (state) => {
    return state.unreadMsgCount
  },
}

const mutations = {
  setUnreadMsgCount(state, count) {
    state.unreadMsgCount = count
  },
}

const actions = {
  setUnreadMsgCount({ commit }) {
    getMsgBadge().then((data) => {
      if (data && data.state) {
        commit('setUnreadMsgCount', data.value)
      }
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
